export default __webpack_public_path__ + "static/media/restaurant.35123c30.jpg";